<template>
  <b-modal
    id="modal-user-conf"
    ref="bModal"
    size="xl"
    hide-footer
    centered
    :title="$t('userConfiguration.configuration')"
    modal-class="confModal"
    @hidden="onHidden"
  >
    <b-row>
      <b-col class="px-2">
        <div style="height:calc(60vh - 40px)">
          <b-tabs
            v-model="tabIndex"
            pills
            card
            vertical
            class="vt-tabs--pills"
            content-class="mt-3"
          >
            <b-tab lazy>
              <template slot="title">
                <i
                  class="far fa-user mr-2"
                  aria-hidden="true"
                />
                {{ $t('userConfiguration.basicConfiguration') }}
              </template>
              <general-user-conf
                v-if="tabIndex === TAB_GENERAL_CONF"
                ref="generalUserConf"
                :user-information="userInformation"
              />
            </b-tab>
            <b-tab lazy>
              <template slot="title">
                <i
                  class="far fa-lock mr-2"
                  aria-hidden="true"
                />
                {{ $t('userConfiguration.password') }}
              </template>
              <password-user-conf
                v-if="tabIndex === TAB_PASSWORD_CONF && canChangePassword"
                ref="passwordUserConf"
                :user-information="userInformation"
              />
            </b-tab>
            <b-tab lazy>
              <template slot="title">
                <i
                  class="far fa-window-restore mr-2"
                  aria-hidden="true"
                />
                {{ $t('userConfiguration.dialog') }}
              </template>
              <modals-user-conf
                v-if="tabIndex === TAB_MODALS_CONF"
                ref="modalsUserConf"
              />
            </b-tab>
            <b-tab lazy>
              <template slot="title">
                <i
                  class="far fa-print mr-2"
                  aria-hidden="true"
                />
                {{ $tc('printService.printers') }}
              </template>
              <user-configuration-print-tab
                v-if="tabIndex === TAB_PRINTER_CONF"
                ref="printsUserConf"
              />
            </b-tab>
            <b-tab lazy>
              <template slot="title">
                <i
                  class="far fa-home mr-2"
                  aria-hidden="true"
                />
                {{ $t('userConfiguration.defaultAccesses') }}
              </template>
              <access-user-conf
                v-if="tabIndex === TAB_ACCESS_CONF"
                ref="accessUserConf"
              />
            </b-tab>
          </b-tabs>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import GeneralUserConf from '@/components/userConfiguration/GeneralUserConf'
import ModalsUserConf from '@/components/userConfiguration/ModalsStateUserConf'
import AccessUserConf from '@/components/userConfiguration/AccessUserConf'
import PasswordUserConf from '@/components/userConfiguration/PasswordUserConf'
import UserConfigurationPrintTab from '@/components/userConfiguration/print/tab/user-configuration-print-tab.vue'
import { auth } from '@/api/auth'

const TAB_GENERAL_CONF = 0
const TAB_PASSWORD_CONF = 1
const TAB_MODALS_CONF = 2
const TAB_PRINTER_CONF = 3
const TAB_ACCESS_CONF = 4

export default {
    name: 'ModalUserConf',
    components: {
        GeneralUserConf,
        ModalsUserConf,
        UserConfigurationPrintTab,
        AccessUserConf,
        PasswordUserConf
    },
    props: {
        tabPosition: { type: Number, default: TAB_GENERAL_CONF }
    },
    data() {
        return {
            tabIndex: null,
            devices: [],
            printers: [],
            workstation: '',
            user: {},
            canChangePassword: true
        }
    },
    computed: {
        TAB_GENERAL_CONF() {
            return TAB_GENERAL_CONF
        },
        TAB_PASSWORD_CONF() {
            return TAB_PASSWORD_CONF
        },
        TAB_MODALS_CONF() {
            return TAB_MODALS_CONF
        },
        TAB_PRINTER_CONF() {
            return TAB_PRINTER_CONF
        },
        TAB_ACCESS_CONF() {
            return TAB_ACCESS_CONF
        },
        userInformation() {
            return this.$store.getters.userInformation
        }
    },
    methods: {
        hide() {
            this.$refs.bModal.hide()
        },
        onHidden() {
            if (this.$refs.generalUserConf) {
                this.$refs.generalUserConf.clearData()
            }
        },
        async show() {
            this.tabIndex = this.tabPosition
            this.canChangePassword = await auth.canChangePassword()
            if (this.tabPosition === TAB_PASSWORD_CONF) {
                this.tabIndex = TAB_GENERAL_CONF
            }
            this.$refs.bModal.show()
        }
    }
}
</script>

<style lang="scss">
.confModal .tab-container {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.confModal .tab-container .tab-header {
    padding: 15px 18px;
    position: sticky;
    top: 0;
    background: #fff;
}
.confModal .tab-container .tab-body {
    flex-grow: 1;
    overflow-y: auto;
    padding: 0 15px;
    margin: 5px;
}
.confModal .tab-container .tab-footer {
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: sticky;
    bottom: 0;
    background: #fff;
}

.confModal .section-icon {
    width: 26px;
}

.confModal .option-row {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.confModal .option {
  font-size: font-size(very-small);
  color: vt-color(dark-text);
}

.confModal .selected-option {
  font-size: font-size(small);
}

.confModal .title {
  color: vt-color(primary);
  font-size: font-size(normal);
}

.confModal .subtitle {
  color: vt-color(dark-text);
  font-size: font-size(very-small);
}

.confModal .type {
  font-size: font-size(very-small);
}

.confModal .tab-content {
  height: calc(67vh - 40px);
}

.confModal .sticky-header {
    background: #FFF;
    position: sticky;
    top: 0;
    z-index: 1;
}

.confModal .card-header {
  background: transparent;
  width: 200px;
}

.confModal .tabs.vt-tabs {
  height: 100%;
}

.confModal .tab-content > .tab-pane {
    padding: 0;
    height: 100%;
}

.confModal .printer-row {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  padding: 12px;
}

.confModal .language-row {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.confModal .modal-body {
  height: calc(67vh - 10px);
    border-radius: 0.3rem;
}

.confModal .password-modal .modal-body{
  height: auto;
}

.confModal .footer-banner {
  width: 100%;
}

.confModal .color-main i{
    color: vt-color(primary) !important;
}

.confModal .color-main span{
    color: vt-color(primary) !important;
}

.confModal .extended-list .printer-row-wrapper:nth-last-child(-n+3) .multiselect__content-wrapper {
    bottom: 100%;
}

.confModal .path-input-group .input-group-text {
    background-color: transparent;
    border-color: #7d7d7d;
    border-right: 0;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}

.confModal .path-input-group .path-input {
    border-left: 0;
    position: relative;
}

.confModal .path-input-group:focus-within .input-group-text,
.confModal .form-control:focus ~ .input-group-append .input-group-text {
    border-color: #c6d8ff;
}

@media (max-width: 1300px) {
  .confModal .footer-banner a {
    font-size: 0.9rem;
  }

  .links-modals a {
    font-size: 0.9rem !important;
  }
}

@media only screen and (max-width: 1366px) and (min-width: 1360px) {
  .confModal .modal-body {
  height: calc(100vh - 200px);
}

.confModal .tab-content {
  height: calc(100vh - 240px);
}
}

.printerConfiguration-form-group {
  margin-bottom: 25px;

    ::v-deep legend,
  label {
    font-size: font-size(small);
    padding-bottom: 0;
    margin-bottom: 0;
    font-weight: bold;
    color: black;
  }
}

.printerConfiguration-button {
  margin-bottom: 35px;
}
</style>

<style lang="scss" scoped>
.color-main i{
  color: vt-color(primary) !important;
}

.color-main span{
  color: vt-color(primary) !important;
}
</style>
